import { useField, useFormikContext } from "formik";
import { omit } from "ramda";

import InlineInput from "./InlineInput";

const FormikInlineInput = ({ name, ...props }) => {
  const [field, meta, { setValue, setTouched }] = useField(name);

  const { submitForm, isSubmitting, resetForm, dirty } = useFormikContext();

  const handleSubmit = value => {
    setValue(value);

    props.handleSubmit?.(value);

    return submitForm();
  };

  return (
    <InlineInput
      error={meta.touched ? meta.error : ""}
      isSaving={isSubmitting}
      {...props}
      handleCancel={() => {
        resetForm();
        props.handleCancel?.();
      }}
      {...{ handleSubmit, ...omit(["onBlur"], field), dirty }}
      onInlineInputBlur={trimmedValue => {
        setValue(trimmedValue);
        setTouched(true);
      }}
    />
  );
};

export default FormikInlineInput;
